import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddAwbComponent } from 'src/app/components/operation/awb/add/add.component';
import { ListAwbComponent } from 'src/app/components/operation/awb/list/list.component';
import { EditAwbComponent } from 'src/app/components/operation/awb/edit/edit.component';
import { TrackingComponent } from 'src/app/components/operation/tracking/tracking.component';
const routes: Routes = [
  { path: '', component: ListAwbComponent },
  { path: 'add', component: AddAwbComponent },
  { path: 'edit/:id', component: EditAwbComponent },
  { path: 'copytonew/:id', component: EditAwbComponent },
  { path: 'track', component: TrackingComponent },
  { path: 'track/:awbnumber', component: TrackingComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AwbRoutingModule { }
